// @ts-nocheck
import { ChipsGroup } from './common/ChipsGroup/ChipsGroup'
import { IconWithText } from './common/IconWithText/IconWithText'
import { Text } from './common/Text/Text'

export const BUTTON = 'button'
export const CHIP_GROUP = 'chipsGroup'
export const ICON_WITH_TEXT = 'iconWithText'
export const TEXT = 'text'

export const getContent = type => {
  const contents = {
    // TODO: add relevant button component when
    // working on the edit job page
    [BUTTON]: null,
    [CHIP_GROUP]: ChipsGroup,
    [ICON_WITH_TEXT]: IconWithText,
    [TEXT]: Text,
  }

  return contents[type]
}
